module.exports = __webpack_public_path__ + "img/imgZXGH(20).92cd3fea.png";